import { render, staticRenderFns } from "./ProductsABC.vue?vue&type=template&id=9d55f9ec&"
import script from "./ProductsABC.vue?vue&type=script&lang=js&"
export * from "./ProductsABC.vue?vue&type=script&lang=js&"
import style0 from "./ProductsABC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports